import React from 'react';
import { DocumentTextIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import Card, { CardHeader } from '../ui/Card';
import CalendarSyncCard from './CalendarSyncCard';
import RoomPreferenceCard from './RoomPreferenceCard';
import BookingAccessCard from './BookingAccessCard';

/**
 * Clinician Settings page — private, "set-once-and-forget" controls and
 * integrations. Profile remains the public-identity surface; this is where
 * personal config (calendar sync, member resources, future notification prefs
 * / security) lives.
 */
const RESOURCES = [
  { label: 'Member Handbook', href: '/Clinic%20Studios%20-%20Member%20Handbook.pdf' },
  { label: 'House Rules', href: '/Clinic%20Studios%20-%20House%20Rules.pdf' },
];

const MemberSettings: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-clinic-dark">Settings</h1>
        <p className="text-clinic-muted mt-2">
          How your practice runs — booking access, room preference, and integrations.
        </p>
      </div>

      <div className="max-w-2xl space-y-6">
        <BookingAccessCard />
        <RoomPreferenceCard />
        <CalendarSyncCard />

        {/* Member resources — relocated here from the login footer (these are
            member documents, not patient-facing login content). */}
        <Card className="p-6">
          <CardHeader title="Member Resources" />
          <div className="space-y-2">
            {RESOURCES.map((r) => (
              <a
                key={r.label}
                href={r.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between rounded-lg border border-clinic-primary-lighter px-4 py-3 text-sm text-clinic-dark hover:bg-clinic-cream transition-colors"
              >
                <span className="flex items-center">
                  <DocumentTextIcon className="h-5 w-5 mr-2 text-clinic-muted" />
                  {r.label}
                </span>
                <ArrowTopRightOnSquareIcon className="h-4 w-4 text-clinic-muted" />
              </a>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default MemberSettings;
